
export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24 py-28 sm:py-36 md:py-44 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8 sm:space-y-12">
          <div className="mb-6 sm:mb-8">
            <img
              src="https://static.readdy.ai/image/80932669f31e28b86429da114025ac51/08dec07d3c53a8364cfccdbeb3d31cd3.png"
              alt="Naturi"
              className="mx-auto h-64 sm:h-80 md:h-88 lg:h-96 w-auto"
              loading="eager"
              fetchPriority="high"
            />
          </div>

          <div className="space-y-6 sm:space-y-8">
            <h1 className="text-[1.25rem] sm:text-2xl md:text-3xl lg:text-4xl text-[#333333] leading-[1.7] tracking-wider font-normal">
              DXと教育で<br />
              企業の「自走」を支援する。
            </h1>

            <p className="text-[0.75rem] sm:text-sm md:text-base text-[#666666] leading-[1.9] max-w-2xl mx-auto font-light tracking-wide">
              <span className="inline-block">事業戦略立案、P/L設計、KPI設計、</span>
              <span className="inline-block">運用、e-learning研修まで。</span>
              <br className="hidden sm:block" />
              <span className="inline-block">企業のDX推進と売上拡大を一貫して支援します。</span>
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <button
              onClick={scrollToContact}
              className="px-8 sm:px-12 py-3.5 bg-[#6b8e6b] text-white text-sm font-light tracking-wider hover:bg-[#5a7a5a] transition-all cursor-pointer whitespace-nowrap rounded-sm"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
